// extracted by mini-css-extract-plugin
module.exports = {"indicator":"styles_indicator__2pYmH","pulse":"styles_pulse__Kr6KX"};